import { c as _c } from "react/compiler-runtime";
import { FaroTextButton } from "@components/common/faro-text-button";
import { SphereAvatar } from "@components/header/sphere-avatar";
import { UpdateProfilePictureDialog } from "@components/user-info/update-profile-picture-dialog";
import { assert } from "@faro-lotv/foundation";
import { Grid } from "@mui-wrapper";
import { useUserContext } from "@pages/account-settings/user-provider";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { getUserInitials } from "@utils/user-utils";
import { useState } from "react";

/** Renders profile picture section item in member account page */
export function AccountProfilePicture() {
  const $ = _c(17);
  const {
    user
  } = useUserContext();
  assert(user, "User has to be defined to show/change profile picture");
  const [isProfilePictureDialogOpen, setIsProfilePictureDialogOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "nowrap"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = user.thumbnailUrl;
  let t2;
  if ($[1] !== user) {
    t2 = getUserInitials(user);
    $[1] = user;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2 || $[4] !== user.thumbnailUrl) {
    t3 = <SphereAvatar src={t1} initials={t2} icon={undefined} shouldUseSimplifiedAvatar={true} shouldHideWhiteRim={true} size="large" />;
    $[3] = t2;
    $[4] = user.thumbnailUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsProfilePictureDialogOpen(true);
    t5 = {
      fontSize: DEFAULT_INPUT_FONT_SIZE,
      fontWeight: DEFAULT_BOLD_TEXT_FONT_WEIGHT
    };
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  const t6 = user.thumbnailUrl ? "Change picture" : "Add";
  let t7;
  if ($[8] !== t6) {
    t7 = <FaroTextButton onClick={t4} sx={t5}>{t6}</FaroTextButton>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isProfilePictureDialogOpen || $[11] !== user) {
    t8 = <UpdateProfilePictureDialog user={user} isDialogOpen={isProfilePictureDialogOpen} setIsDialogOpen={setIsProfilePictureDialogOpen} />;
    $[10] = isProfilePictureDialogOpen;
    $[11] = user;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t7 || $[15] !== t8) {
    t9 = <Grid container={true} direction="row" sx={t0}>{t3}{t7}{t8}</Grid>;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}